import React from "react";

const Heading = ({ heading, seoId }) => {
  // Create an SEO-friendly ID for internal linking if not provided
  const cleanId = seoId
    ? seoId
    : heading?.toLowerCase().replace(/[^a-z0-9]+/g, "-");

  return (
    <header id={cleanId} className="pb-6">
      {/* Semantic SEO heading */}
      <h1 
        className="text-3xl font-semibold leading-snug text-gray-900"
        title={`${heading} – Verified Section Title for Better Search Ranking`}
      >
        {heading}
      </h1>
    </header>
  );
};

export default Heading;
